import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class CustomVariableBlot extends Embed {
  static blotName = 'customVariable';
  static tagName = 'SPAN';
  static className = 'custom-variable-blot';

  // Create HTML node
  static create(value) {
    const node = super.create(value);

    if (typeof value === 'string') {
      node.setAttribute('data-value', value);
      node.textContent = `${value}`;
    }

    return node;
  }

  static value(domNode) {
    return domNode.getAttribute('data-value');
  }
}

export default CustomVariableBlot;
